import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useFetchCategoryGroupsDictQuery } from "../../../../api/rtk/base/slices/roadCategorySegmentsApiSlice";
import { Loader } from "../../../loaders/Loader";

export default function RoadsLengthByCategoryGraph() {
    const [graphData, setGraphData] = useState<any>(null)
    const [graphIsShown, setGraphIsShown] = useState<boolean>(true)
    const [graphXAxisTicks, setGraphXAxisTicks] = useState<any>([])

    const {
        data: categoryGroups,
        isFetching: categoryGroupsAreFetching,
        isError: categoryGroupsRequestIsError
    } = useFetchCategoryGroupsDictQuery({})

    useEffect(() => {
        let hasAtLeastOneFilled = false
        if (categoryGroups) {
            const year = 2024;
            let data = { year }
            let maxDataX = 0
            categoryGroups.value.map((categoryGroup: any) => {
                const { CategoryId, Length } = categoryGroup ?? {}
                if (Length > maxDataX) maxDataX = Length
                if (Length) hasAtLeastOneFilled = true
                data = { ...data, [CategoryId]: Length.toFixed(1) }
            })
            setGraphData([data])
            const ticks = Array.from(
                { length: Math.floor((maxDataX + 1000) / 500) + 1 },
                (_, i) => i * 500
            );
            setGraphXAxisTicks(ticks)
        }
        setGraphIsShown(hasAtLeastOneFilled)
    }, [categoryGroups])

    const labelStyle: any = { fill: "black", position: 'top', fontSize: "13" }
    const yearAxisTickFormatter = (value: any) => `${value} г.`
    const legendFormatter = (value: any) => <span className="legend-text">{value}</span>

    const graphTooltipTemplate: any = ({ payload }: any) => {
        const graphData = payload[0]?.payload
        const { year, 1: Ia, 2: Ib, 3: II, 4: III, 5: IV, 6: V, 999999: otherCategoryGroups, } = graphData ?? {}
        return (
            <div className="graph-tooltip">
                <p>Год: <strong>{year}</strong></p>
                {Ia && <p>I-a: <span id="ia-value">{Ia}</span> км</p>}
                {Ib && <p>I-б: <span id="ib-value">{Ib}</span> км</p>}
                {II && <p>II: <span id="ii-value">{II}</span> км</p>}
                {III && <p>III: <span id="iii-value">{III}</span> км</p>}
                {IV && <p>IV: <span id="iv-value">{IV}</span> км</p>}
                {V && <p>V: <span id="v-value">{V}</span> км</p>}
                {otherCategoryGroups && <p>Другие: <span id="other-category-groups-value">{otherCategoryGroups}</span> км</p>}
            </div>
        )
    }

    return (
        <>
            {categoryGroupsAreFetching
                ?
                <Loader />
                :
                <>
                    {graphIsShown
                        ?
                        <ResponsiveContainer width="100%" height={357}>
                            <BarChart
                                data={graphData}
                                layout="horizontal"
                                margin={{ right: 30, bottom: 15, top: 15 }}
                                className="roads-length-by-category-graph"
                            >
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <YAxis type="number" ticks={graphXAxisTicks} axisLine={false} tickLine={false} tick={{ fill: "#999999" }} />
                                <XAxis dataKey="year" tickFormatter={yearAxisTickFormatter} tick={{ fill: "black" }} />
                                <Legend formatter={legendFormatter} align="center" />
                                <Tooltip content={graphTooltipTemplate} />
                                <Bar dataKey="1" name="I-a" fill="#b38dd9" barSize={30} label={labelStyle} />
                                <Bar dataKey="2" name="I-б" fill="#6a5acd" barSize={30} label={labelStyle} />
                                <Bar dataKey="3" name="II" fill="#005CC2" barSize={30} label={labelStyle} />
                                <Bar dataKey="4" name="III" fill="#7DA2DF" barSize={30} label={labelStyle} />
                                <Bar dataKey="5" name="IV" fill="#1faee9" barSize={30} label={labelStyle} />
                                <Bar dataKey="6" name="V" fill="#afdafc" barSize={30} label={labelStyle} />
                                <Bar dataKey="999999" name="Другие" fill="#08e8de" barSize={30} label={labelStyle} />
                            </BarChart>
                        </ResponsiveContainer>
                        :
                        <div className="panel-no-content">
                            <span>Нет информации</span>
                        </div>
                    }
                </>
            }
        </>
    )
}
